/* 🤖 this file was generated by svg-to-ts */
export const DfIconArrowDownRight16: {
  name: 'arrow-down-right-16';
  data: string;
} = {
  name: 'arrow-down-right-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M11 9H1a1 1 0 0 1-1-1V1a1 1 0 1 1 2 0v6h9V4.51a.5.5 0 0 1 .829-.377l4 3.491a.5.5 0 0 1 0 .753l-4 3.505a.5.5 0 0 1-.829-.376z"/></svg>`
};
